/* eslint-disable react/prop-types */
import React, { useState } from "react";
import { styled } from "styled-components";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";
import Pagination from "../Pagination/index";

const MainContainer = styled.div`
  // padding: 0 100px 60px 100px;
`;

function GenericTable({ data, tableData, headers, onPageChange }) {
  const [currentPage, setCurrentPage] = useState(0);

  const handleChangePage = (selectedPage) => {
    setCurrentPage(selectedPage.selected);
    onPageChange(selectedPage.selected);
  };

  const pageCount = data.totalPages;

  return (
    <MainContainer>
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow
              style={{
                background:
                  "linear-gradient(180deg, #2A93C1 0%, #1D7196 87.50%, #BCD4DE 100%)",
              }}
            >
              {headers.map((header) => (
                <TableCell
                  key={header}
                  sx={{
                    fontWeight: "bold",
                    color: "white",
                    padding: "10px",
                    textAlign: "center",
                  }}
                >
                  {header}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {tableData.map((row, index) => (
              <TableRow
                key={row.id}
                sx={{ background: index % 2 === 1 ? "#E8F6FC" : "#ffffff" }}
              >
                {headers.map((header) => (
                  <TableCell
                    key={header}
                    sx={{
                      borderBottom:
                        index % 2 === 1 ? "1px solid #62B6DA" : "#ffff",
                      borderTop:
                        index % 2 === 1 ? "1px solid #62B6DA" : "#ffff",
                      textAlign: "center",
                    }}
                  >
                    {row[header]}
                  </TableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <Pagination
        pageCount={pageCount}
        onPageChange={handleChangePage}
        forcePage={currentPage}
      />
    </MainContainer>
  );
}

export default GenericTable;
